import { PagesTableType, pagesSchema } from 'client/db/tables/pages'
import Dexie from 'dexie'

type DexieTablesType = PagesTableType

type DexieType<T = DexieTablesType> = Dexie & T

const database = new Dexie('database') as DexieType

const schema = { ...pagesSchema }

database.version(1).stores(schema)

export default database
